export default "__VITE_ASSET__00db7efa__"